import { render, staticRenderFns } from "./OrderableShippingAddress.vue?vue&type=template&id=54709630&"
import script from "./OrderableShippingAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderableShippingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports